<div
  class="relative w-32 h-32 cursor-pointer transition-transform duration-300 hover:scale-105"
  [class.opacity-75]="stampImage"
  (click)="fileInput.click()"
>
  <!-- Default stamp design -->
  <div
    class="w-full h-full border-4 border-gray-800 rounded-full flex items-center justify-center bg-white shadow-lg"
    *ngIf="!stampImage"
  >
    <div
      class="w-full h-full flex flex-col justify-between items-center p-2 text-center"
    >
      <!-- Company name at top -->
      <div
        class="text-xs font-bold text-gray-800 uppercase leading-tight tracking-wide break-words"
      >
        {{ companyName || "COMPANY NAME" }}
      </div>

      <!-- Center SEAL text -->
      <div class="flex-1 flex items-center justify-center">
        <div class="text-lg font-bold text-gray-800 tracking-widest">SEAL</div>
      </div>

      <!-- Bottom details -->
      <div class="text-xs text-gray-700 leading-tight">
        <div class="font-semibold">{{ registrationNo || "RC XXXXXX" }}</div>
        <div class="text-xs mt-1">{{ location || "LAGOS, NIGERIA" }}</div>
      </div>
    </div>
  </div>

  <!-- Display uploaded stamp image -->
  <div
    class="w-full h-full rounded-full overflow-hidden border-2 border-gray-300"
    *ngIf="stampImage"
  >
    <img
      [src]="stampImage"
      alt="Company Stamp"
      class="w-full h-full object-cover"
    />
  </div>

  <!-- Upload overlay -->
  <div
    class="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-30 rounded-full flex items-center justify-center transition-all duration-300 group"
  >
    <div
      class="text-center text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"
    >
      <svg
        class="w-8 h-8 mx-auto mb-2"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
        />
      </svg>
      <div class="text-sm font-medium">
        {{ stampImage ? "Change" : "Upload" }}
      </div>
      <div class="text-xs">(Max. 5MB)</div>
    </div>
  </div>

  <input
    #fileInput
    type="file"
    accept="image/*"
    (change)="onFileSelected($event)"
    class="hidden"
  />
</div>
